import styled from '@emotion/styled';

import { ModalContent } from 'components/global/styled/Modal.styled';

import { Breakpoints } from 'utils/const.styles';

export const LogoContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 2.6rem;
`;
export const Container = styled(ModalContent)`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 2.6rem;
	padding: var(--padding-5);

	@media ${Breakpoints.mobile} {
		padding: 4rem var(--padding-5);
	}
`;
